import { Injectable } from '@angular/core';
import { ErrorResponse } from '../entities/error-response';
import { ClientSSO } from '../entities/client-sso';

import { StoreService } from '../stores/store.service';
import { StatusCode } from '../entities/status-code';
import { LABELS } from '../constants/labels.constant';

const clientErrorCodes = {
  [StatusCode.InvalidCredentials]: LABELS.invalidCredentials, // 'Invalid email, auth key or password.'
  [StatusCode.AccountIsNotReachable]: LABELS.accountIsNotReachable, //'Account is not reachable. To access the application please'
  [StatusCode.EmailIsNotRegistered]: LABELS.emailIsNotRegistered, // Email is not registered. Please register your email or
  [StatusCode.UserNotExternal]: LABELS.userNotExternal,
  [StatusCode.AccountIsLocked]: LABELS.accountIsLocked, //Account is locked. To access the application please
  [StatusCode.InvalidClientName]: LABELS.invalidClientName,
  [StatusCode.SSOonly]: LABELS.SSOonly, //Named login is disabled. Please login with SSO.
  [StatusCode.InvalidSsoClientConfig]: LABELS.invalidSsoClientConfig,
  [StatusCode.InvalidSamlToken]: LABELS.invalidSamlToken,
  [StatusCode.InvalidEmail]: LABELS.invalidEmail, //Invalid email.
};

const generalErrorCodes = {
  1: LABELS.generalInvalidCredentials, // 'Invalid email, auth key or password.'
  2: LABELS.generalAccountIsNotReachable, //'Account is not reachable. To access the application please'
  3: LABELS.generalEmailIsNotRegistered, // Email is not registered. Please register your email or
  4: LABELS.generalClientNotFound,
  11: LABELS.generalAccountIsLocked, //Account is locked. To access the application please
  12: LABELS.generalClientNotFound, //Invalid client name.
  22: LABELS.generalClientNotFound, //Invalid client name.
  23: LABELS.generalForgotPassword,
};

@Injectable()
export class ErrorsSevice {
  constructor(private storeService: StoreService) {}

  public getErrors(errorResponse: ErrorResponse): string {
    const errorCode = errorResponse.errorCode;
    const errorText = (code: number) => (errorCodeObject: any) => errorCodeObject[code] || 'Unknown error code' + code;
    const client: ClientSSO = this.storeService.client;

    if (client) {
      return errorText(errorCode)(clientErrorCodes);
    } else {
      return errorText(errorCode)(generalErrorCodes);
    }
  }
}
